module.exports = __webpack_public_path__ + "img/fabricate.056582a8.png";